import useI18n from '@app/shared/vue/composables/use-I18n'
import type { LockType, PeriodSelectionType } from '../types'
import { lockTypes } from '../types'

export const isLockType = (value: string): value is LockType =>
  Object.values<string>(lockTypes).includes(value)

export const lockTypeTitle = (
  periodSelection: PeriodSelectionType,
  lockType: LockType
): string =>
  useI18n().t(
    `companies_overview.period_selection_new.${periodSelection}_options.${lockType}`
  )

export const lockTypeLabel = (
  periodSelection: PeriodSelectionType,
  lockType: LockType
): string => lockTypeTitle(periodSelection, lockType).toLowerCase()
